import { post } from '@/request';

const trackerApi = {
  initUser(data) {
    return post('/nfm/tracker/ua/init', data);
  }
};
export default trackerApi;
